import e from "../../utils/classNames.js";
import { forwardRef as t, useEffect as n, useImperativeHandle as r, useRef as i } from "react";
import { debounce as a, noop as o } from "es-toolkit/function";
import { jsx as s } from "react/jsx-runtime";
import { Scrollbars as c } from "react-custom-scrollbars-4";
//#region src/components/smoothScrollbars/SmoothScrollbars.tsx
var l = 100, u = t((t, u) => {
	let { slideIn: d = !1, largeTrack: f = !1, trackOffset: p = !1, className: m = "", onScroll: h = o, tagName: g = "div", autoHeight: _ = !1, autoHeightMin: v = 0, autoHeightMax: y = 200, children: b, style: x, ...S } = t, C = i(null), w = i(null);
	r(u, () => C.current, []), n(() => {
		if (!w.current || !C.current) return;
		let e = a(() => {
			C.current && C.current.update();
		}, l), t = new ResizeObserver(e);
		return t.observe(w.current), () => {
			t.disconnect(), e.cancel();
		};
	}, []);
	let T = e(m, d && "scrollbar-fly-in", "smooth-scrollbar-wrapper"), E = e("scrollbar-track-vertical", f && "scrollbar-track-size-large", p && "scrollbar-track-offset"), D = e("scrollbar-thumb-vertical", f && "scrollbar-thumb-size-large"), O = e("scrollbar-track-horizontal", f && "scrollbar-track-size-large", p && "scrollbar-track-offset"), k = e("scrollbar-thumb-horizontal", f && "scrollbar-thumb-size-large");
	return /* @__PURE__ */ s(c, {
		...S,
		ref: C,
		tagName: g,
		onScroll: h,
		className: T,
		hideTracksWhenNotNeeded: !0,
		autoHeight: _,
		autoHeightMin: v,
		autoHeightMax: y,
		renderView: (e) => /* @__PURE__ */ s("div", {
			...e,
			className: "scrollbar-view"
		}),
		renderTrackVertical: (e) => /* @__PURE__ */ s("div", {
			...e,
			className: E
		}),
		renderThumbVertical: (e) => /* @__PURE__ */ s("div", {
			...e,
			className: D
		}),
		renderTrackHorizontal: (e) => /* @__PURE__ */ s("div", {
			...e,
			className: O
		}),
		renderThumbHorizontal: (e) => /* @__PURE__ */ s("div", {
			...e,
			className: k
		}),
		children: /* @__PURE__ */ s("div", {
			className: "scrollbar-content-wrapper",
			ref: w,
			children: b
		})
	});
});
//#endregion
export { u as default };

//# sourceMappingURL=SmoothScrollbars.js.map